<template>
  <aw-dropdown
    v-if="show"
    placement='bottom-end'
    :offset='[0, 6]'
    class='relative'
  >
    <template v-slot:btn='{ toggle }'>
      <div @click="open(toggle)" class="HeaderCart__Icon flex cursor-pointer">
        <aw-icon
          icon='cart'
          class='w-5 h-5 text-gray-200 hover:text-gray-400'
        ></aw-icon>
      </div>
    </template>
    <template v-slot:dropdown='{ opened, dropdown }'>
      <div
        v-show='opened'
        :ref='dropdown'
        class='Dropdown Dropdown--Notifications Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10'
      >
        <div v-if='bcCartStore.cart && Object.keys(bcCartStore.cart.products).length'>
          <div class='px-3 py-2 no-hover'>
            <b class="no-hover">{{ $t('Cart Items') }}</b>
          </div>
          <div class='HeaderCart__ProductsWrapper flex flex-col text-gray-600 no-hover overflow-y-scroll'>
            <template v-for='product in this.bcCartStore.cart.products' :key='product.id'>
              <div class="flex justify-between items-center px-3 py-1 border-b border-gray-200">
                <!--
                <img src='https://cdn.aboutstatic.com/file/images/f0d6e68c476c8583d73d492b6fb12333.jpg?width=2000&quality=75&bg=F4F4F5' class='w-12 mr-3 pl-2' alt='' />
                -->
                <div class="flex-1 flex flex-col mt-0.5">
                  <b class="break-all">
                    {{ product.code }}
                  </b>
                  <b class="break-all">
                    {{ product.name }}
                  </b>
                </div>
                <div class="w-1/4 sm:w-1/5 flex justify-center mx-2">
                  <span
                    @click='substractProduct(product.id)'
                    class='cursor-pointer'
                  >
                    <aw-icon
                      icon='minus'
                      class='w-5 h-5 text-gray-400 hover:text-bc-blue'
                    ></aw-icon>
                  </span>
                  <span class="flex-1 text-center mx-1 mt-0.5">
                    {{ product.amount }}
                  </span>
                  <span
                    @click='addProduct(product.id)'
                    class='cursor-pointer'
                  >
                    <aw-icon
                      icon='plus'
                      class='w-5 h-5 text-gray-400 hover:text-bc-blue'
                    ></aw-icon>
                  </span>
                </div>
                <div class='flex-1 text-right mt-0.5 mr-2'>
                  {{ product.price.price_formatted }}
                </div>
                <div class='text-red-600 justify-self-end'>
                  <aw-icon
                    icon='trash'
                    class='w-5 h-5 cursor-pointer'
                    @click='remove(product.id)'
                  />
                </div>
              </div>
            </template>
          </div>
          <div class='flex text-right justify-end px-3 py-1.5 my-3 no-hover'>
            <span class='w-1/4 sm:w-auto flex-grow text-gray-600 mx-2'>
              <b>
                {{ $t('Total price') }}:
              </b>
            </span>
            <span class='flex-1 text-gray-600 mr-2'>
              {{ this.bcCartStore.cart.price.price_formatted }}
            </span>
            <div class="w-5"></div>
          </div>
          <div class="mx-3 my-3">
            <a :href='link' class="w-full btn btn-primary text-center cursor-pointer">{{ $t('Place order') }}</a>
          </div>
        </div>
        <div v-else>
          <div class="px-3 py-2 no-hover">
            <b class="no-hover">{{ $t('Your basket is empty') }}</b>
          </div>
        </div>
      </div>
    </template>
  </aw-dropdown>
</template>

<script>
import { mapStores } from 'pinia'
import useBcCartStore from '@/frontapp/store/bcCart'

export default {
  data() {
    return {}
  },
  props: ['link'],
  computed: {
    ...mapStores(useBcCartStore),
    show() {
      return this.$presenter.hasEshop === 1 && this.$presenter.name !== 'BrandCloud:Eshop:Order'
    }
  },
  methods: {
    addProduct(productId) {
      this.bcCartStore.addProduct(productId)
    },
    substractProduct(productId) {
      this.bcCartStore.substractProduct(productId)
    },
    remove(productId) {
      this.bcCartStore.remove(productId)
    },
    async open(toggle) {
      if (this.bcCartStore.basket === null) {
        await this.bcCartStore.loadCart()
      }
      toggle()
    },
  },
}
</script>

<style lang="scss">
.HeaderCart__Icon {
  margin-top: -0.125rem;
}

.HeaderCart__ProductsWrapper {
  max-height: calc(100vh - 184px);
}
</style>
